// 导入 抽取的 请求对象
import ajaxRequest from '../utils/request'
const reFix = "productAdmin"
// 抽取的接口方法
// 获取列表
export function appList(params){
    return ajaxRequest({
        url: reFix + "/appPublish",
        method:'GET',
        params
    });
}
 

// 添加
export function appAdd(data){
    return ajaxRequest({
        url: reFix + "/appPublish",
        method:'POST',
        data
    })
}

// 删除
export function appRemove(id){
    return ajaxRequest({
        url: reFix + "/appPublish/" + id,
        method:'DELETE'
    })
}
// 更新
export function appEdit(id, data){
    return ajaxRequest({
        url: reFix + "/appPublish/" + id,
        method:'PUT',
        data
    })
}